import { READY, useVisualState } from '../../../../hooks/useVisualState'
import { Form, FormBand } from '../../../../components/Form/Form'
import { oldGet, oldPost } from '../../../../helpers/requestOld'
import { useCallback, useEffect, useRef, useState } from 'react'

import Button from '../../../../components/Button/Button'
import GenericErrorModal from '../../../../modules/GenericErrorModal/GenericErrorModal'
import Modal from '../../../../components/Modal/Modal'
import ModalContent from '../../../../components/Modal/ModalContent'
import ModalFooter from '../../../../components/Modal/ModalFooter'
import ModalHeader from '../../../../components/Modal/ModalHeader'
import PhotoUploader from '../../../../components/PhotoUploader/PhotoUploader'
import ProgressBar from '../../../../components/ProgressBar/ProgressBar'
import React from 'react'
import TextField from '../../../../components/TextField/TextField'
import { closeEvent } from '../../../../components/Modal/ModalEvents'
import t from '../../../../helpers/i18n'
import { uploadFileHelper } from '../../../../helpers/upload'
import useForceUpdate from '../../../../hooks/useForceUpdate'
import useObjectState from '../../../../hooks/useObjectState'
import { useParams } from 'react-router-dom'

const OldCategoryFormModal = ({ onCloseRequested }) => {
  const [formValid, setFormValid] = useState(false)
  const [uploading, setUploading] = useObjectState()
  const [error, setError] = useState()
  const createCategoryData = useRef()
  const createCategoryPending = useRef()
  const uploadModal = useRef()
  const cancel = useRef(false)
  const [[categoryState, category], setCategory] = useVisualState()
  const { categoryId } = useParams()
  const [, forceUpdate] = useForceUpdate()
  const isNew = categoryId === 'new'

  const handleSavePlayer = useCallback(() => {
    setUploading(true)
    uploadFileHelper(createCategoryPending.current, { logo: 'logos' }, setUploading)
      .then(data => {
        if (!cancel.current) {
          oldPost('/cm/categories/' + categoryId, { ...createCategoryData.current, ...data })
            .then(() => onCloseRequested())
            .catch(error => {
              setUploading(false)
              setError(error)
            })
            .finally(() => setUploading(false))
        }
      })

  }, [categoryId, onCloseRequested, setUploading])

  const handleCancelUpload = useCallback(() => {
    cancel.current = true
    closeEvent(uploadModal.current, false)
  }, [])

  useEffect(() => {
    if (isNew) {
      setCategory(READY, {})
    } else {
      oldGet('/cm/categories/' + categoryId)
        .then(response => setCategory(READY, response))
        .catch(error => {
          /*setCategory(ERROR, error)*/
          setCategory(READY, {
            category_id: '123',
            name: "Test category",
            logo: "https://refereeprocm.s3.amazonaws.com/teams/579280370cf235ceb8602643/579280370cf235ceb8602643.20?1469218872",
            short_name: "TC",
            city: "Guadalajara",
            teams_count: 15,
            emails: "a@b.com,csadfdf@dfsfsdf.com"
          })
        })
    }
  }, [setCategory, categoryId, isNew])

  return (
    <div>
      {categoryState === READY &&
        <Modal onCloseRequested={onCloseRequested}>
          <ModalHeader title={isNew ? t('Add new category') : t('Edit category')} />
          <Form data={createCategoryData} pending={createCategoryPending} onValidityChange={setFormValid} onChange={forceUpdate}>
            <ModalContent>
              <FormBand text={t("General Information")} />
              <div className="-layout-21">
                <div>
                  <TextField
                    name="name"
                    label={t('Category name')}
                    mode="entity-name"
                    maxLength={100}
                    minLength={2}
                    required
                    initialValue={category.name}
                  />
                  <TextField
                    name="short_name"
                    label={t('Short name')}
                    mode="entity-name"
                    maxLength={100}
                    minLength={2}
                    required
                    initialValue={category.short_name}
                  />
                </div>
                <div>
                  <PhotoUploader
                    name="logo"
                    label={t('Logo')}
                    aspect={1}
                    source={category.logo}
                  />
                </div>
              </div>
              <TextField
                name="city"
                label={t('City')}
                maxLength={100}
                minLength={2}
                required
                initialValue={category.city}
              />
            </ModalContent>
            <ModalContent>
              <FormBand text={t("Optional Information")} />
              <TextField
                name="emails"
                label={t('Staff emails')}
                maxLength={1000}
                minLength={2}
                required
                initialValue={category.emails}
              />
            </ModalContent>
          </Form>
          <ModalFooter>
            <div>
              <Button onClick={event => closeEvent(event.currentTarget, false)} label={t("Cancel")} />
            </div>
            <div>
              <Button disabled={!formValid} onClick={handleSavePlayer} label={t("Save")} />
            </div>
          </ModalFooter>
          {uploading &&
            <Modal elementRef={uploadModal} onCloseRequested={handleCancelUpload}>
              <ModalHeader title={t("Subiendo archivos...")} back={false} />
              <ModalContent dialog>
                {Object.keys(uploading).map(key =>
                  <div key={key}>
                    <div className="text-label color-text">{FILE_NAMES[key] || createCategoryPending.current[key].value.name}</div>
                    <ProgressBar percent={uploading[key]} />
                  </div>
                )}
              </ModalContent>
            </Modal>
          }
          {error && <GenericErrorModal error={error} i18nPrefix="OldCategoryFormModal" onCloseRequested={() => setError(false)} />}
        </Modal>
      }
    </div>
  )
}

const FILE_NAMES = {
  "logo": t("Category logo")
}

export default OldCategoryFormModal